import React from "react";
import { Box } from "@mui/material";
import MetricsSection from "./MetricsSection";

const EnvironmentalMetrics: React.FC<{ aggMeasureList: any, categoryList: any, detectionDetailPage: (data: any) => void }> = ({
  aggMeasureList,
  categoryList,
  detectionDetailPage
}) => {
  console.log("categoryListcategoryList", categoryList);
  console.log("aggMeasureListaggMeasureList", aggMeasureList);

  const particulatesSubstance =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) =>
            (val.group == "particulate" &&
              val.group !== val.substanceKey &&
              val.substanceKey !== "isopm10psd" &&
              (val.substanceKey == "pcc10" ||
                val.substanceKey == "pcc2dot5")) ||
            val.substanceKey == "pm10" ||
            val.substanceKey == "pm2dot5" ||
            val.substanceKey == "pmdot5" ||
            val.substanceKey == "pcdot5"
        )
        .sort((c1: any, c2: any) => c1.order_no - c2.order_no)) ||
    [];

  const BiosSubstance =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) =>
            (val.group == "bio" &&
              val.group !== val.substanceKey &&
              (val.substanceKey == "pm_bio" ||
                val.substanceKey == "pm_bioi" ||
                val.substanceKey == "pm_biop")) ||
            val.substanceKey == "pc_bio" ||
            val.substanceKey == "pc_bioi" ||
            val.substanceKey == "pc_biop"
        )
        .sort((c1: any, c2: any) => c1.order_no - c2.order_no)) ||
    [];

  const GasesSubstance =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) => val.group == "gas" && val.group !== val.substanceKey
        )
        .sort((c1: any, c2: any) => c1.order_no - c2.order_no)) ||
    [];

  const ChemicalsSubstance =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) => val.group == "chems" && val.group !== val.substanceKey
        )
        .sort((c1: any, c2: any) => c1.order_no - c2.order_no)) ||
    [];

  const wthrTemperature =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) => val.group == "wthr" &&
            (val.substanceKey == "temperature" ||
              val.substanceKey == "humidity") ||
            (val.group == "particulate" && val.substanceKey === "isopm10psd") ||
            (val.group == "thi")
        )) || [];

  const otherTiles =
    (aggMeasureList.length &&
      aggMeasureList
        .filter(
          (val: any) =>
            !val.category_id &&
            val.group !== val.substanceKey || (!val.category_id && val.group === 'thi')
        ).sort((c1: any, c2: any) => c1.order_no - c2.order_no)) || [];

  return (
    <Box sx={{ p: 2, width: "100%", mx: "auto" }}>
      {otherTiles.length > 0 &&
        <MetricsSection title={""} metrics={otherTiles} detectionDetailPage={detectionDetailPage} />
      }
      {categoryList.length > 0 && categoryList.map((item: any) => {
        const tileData =
          (aggMeasureList.length &&
            aggMeasureList
              .filter(
                (val: any) => val.category_id == item.sk && (val.group !== val.substanceKey || val.substanceKey !== "pm2dot5psd")
              ).sort((c1: any, c2: any) => c1.order_no - c2.order_no)) || [];

        return (tileData.length > 0 ? <MetricsSection title={item.category_name} metrics={tileData} detectionDetailPage={detectionDetailPage} /> : null)
      })
      }
      {/* { aggMeasureList.length && <>
        <MetricsSection title="" metrics={wthrTemperature} detectionDetailPage={detectionDetailPage} />
        <MetricsSection title="Particulates" metrics={particulatesSubstance} detectionDetailPage={detectionDetailPage} />
        <MetricsSection title="Bio" metrics={BiosSubstance} detectionDetailPage={detectionDetailPage} />
        <MetricsSection title="Gases" metrics={GasesSubstance}  detectionDetailPage={detectionDetailPage}/>
        <MetricsSection title="Chemicals" metrics={ChemicalsSubstance} detectionDetailPage={detectionDetailPage} />
        </>
      } */}
    </Box>
  );
};

export default EnvironmentalMetrics;
